export const DismissType = {
    DEFAULT: 'default',
    CIRCLE: 'circle'
}